import { http } from "./http"

import { Clients, ClientGroup, NewClient } from "models/clientgroups"

import { Paginated } from "./types"
import { DocType, Document } from "models/documents"

export const fetchClients = async (_key: string, params?: string) => {
  const searchParams = new URLSearchParams(params)
  const res = await http.get("client-groups", { searchParams }).json()
  return res as Paginated<ClientGroup>
}

export const createClient = async (pld: NewClient) => {
  const json = pld
  const res = await http.post("client-groups", { json }).json()
  return res as ClientGroup
}

export const fetchClient = async (
  _key: string,
  id: string,
): Promise<ClientGroup> => await http(`client-groups/${id}`).json()

export const patchClient = async (pld: Partial<ClientGroup>) => {
  const { id, ...data } = pld
  const res = await http.patch(`client-groups/${id}`, { json: data }).json()
  return res as ClientGroup
}

export const fetchUnassignedClients = async (_key: string, params: string) => {
  const searchParams = new URLSearchParams(params)
  searchParams.set("unassigned", "true")
  const res = await http.get(`clients`, { searchParams }).json()
  return res as Paginated<Clients>
}

type AddClientPayload = {
  id: string
  clientIds: Array<string>
}

export const patchUnassignedClients = async (pld: AddClientPayload) => {
  const { id, clientIds } = pld
  const res = await http
    .post(`client-groups/${id}/clients`, { json: { clientIds } })
    .json()
  return res as Paginated<Clients>
}

type DeleteClientPayload = {
  id: string
  clientIds: Array<string>
}

export const patchAssignedClient = async (pld: DeleteClientPayload) => {
  const { id, clientIds } = pld
  await http.delete(`client-groups/${id}/clients`, { json: { clientIds } })
}

export const fetchClientgroupsDocuments = async (_key: string, id: string) => {
  const res = await http(
    `client-groups/${id}/documents?sort=DATE_CREATED,DESC`,
  ).json()
  return res as Array<Document>
}

type UploadClientgroupsCodPld = {
  file?: File
  mediaType?: string
  description?: string
  ownerEntityId: string
  documentType?: DocType
  tags?: string
}

export const uploadClientgroupsDocument = async (
  pld: UploadClientgroupsCodPld,
) => {
  if (pld.file === undefined) return
  const { file, ownerEntityId, documentType, description } = pld
  const formData = new FormData()
  formData.append("file", file)
  formData.append("name", file.name)
  if (documentType !== undefined) {
    formData.append("documentType", documentType)
  }
  if (description !== undefined) {
    formData.append("description", description)
  }

  const res = await http
    .post(`client-groups/${ownerEntityId}/documents`, {
      body: formData,
      timeout: false,
    })
    .json()
  return res
}

export const deleteClientgroupsDocument = async (id: string) => {
  await http.delete(`client-groups/documents/${id}`)
}

export const deleteClient = async (id: string) =>
  await http.delete(`client-groups/${id}`)
